export const chatGroupEnum = {
  OneToOne: 1,
  GymGroup: 2,
  TrackGroup: 3,
  CustomGroup: 4,
};
